/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
const CSS = {
  menu: "menu",
  defaultTrigger: "default-trigger"
};
const idPrefix = "calcite-action-menu";
const IDS = {
  button: (id) => `${idPrefix}-${id}-menu-button`,
  menu: (id) => `${idPrefix}-${id}-menu`,
  action: (id, actionId) => `${idPrefix}-${id}-action-${actionId}`
};
const SLOTS = {
  tooltip: "tooltip",
  trigger: "trigger"
};
const ICONS = {
  menu: "ellipsis"
};
export {
  CSS as C,
  IDS as I,
  SLOTS as S,
  ICONS as a
};
